/**
 * Loads the BSB/KAP chart manifest the converter writes. Mirrors how the ENC
 * cell manifest is fetched. Missing (no charts converted yet) or malformed is
 * not an error — it just means no BSB charts, so the provider stays empty.
 */
import { BSB_MANIFEST_PATH, type RasterChart } from './providers';

function isRasterChart(c: unknown): c is RasterChart {
  if (!c || typeof c !== 'object') return false;
  const r = c as Record<string, unknown>;
  return (
    typeof r.id === 'string' &&
    typeof r.name === 'string' &&
    Array.isArray(r.bounds) &&
    r.bounds.length === 4 &&
    r.bounds.every((n) => typeof n === 'number') &&
    typeof r.path === 'string' &&
    typeof r.tileMinZoom === 'number' &&
    typeof r.tileMaxZoom === 'number' &&
    typeof r.nativeZoom === 'number'
  );
}

export async function loadBsbManifest(): Promise<RasterChart[]> {
  const base = import.meta.env.BASE_URL ?? '/';
  try {
    const res = await fetch(`${base}${BSB_MANIFEST_PATH}`);
    if (!res.ok) return [];
    const data: unknown = await res.json();
    const charts = (data as { charts?: unknown })?.charts;
    return Array.isArray(charts) ? charts.filter(isRasterChart) : [];
  } catch {
    return [];
  }
}
